<div fxLayout fxLayoutAlign="start center" class="detail-subheader">
  <strong fxFlex>{{ label }}</strong>
  <sbnb-property-update-status
    [edited]="edited"
    [hasAirbnbListing]="hasAirbnbListing"></sbnb-property-update-status>
  <!-- <sbnb-button
    *ngIf="!editMode"
    size="mini"
    label="Edit"
    type="text"
    (click)="editMode = true"
  ></sbnb-button> -->
</div>
<div fxLayout="row wrap" fxLayoutGap="8px" *ngIf="!editMode">
  <span class="night text__small" *ngIf="!languages || languages?.length === 0">Unknown</span>
  <span class="amenity-badge" *ngFor="let language of languages">{{ language }}</span>
</div>

<!-- Edit mode -->
<div [hidden]="!editMode">
  <mat-selection-list dense #langList>
    <mat-list-option *ngFor="let lang of availableLanguages" [selected]="languages?.indexOf(lang) > -1" [value]="lang">
      {{ lang }}
    </mat-list-option>
  </mat-selection-list>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 12px">
    <sbnb-button label="Cancel" type="secondary" size="mini" (clicked)="editMode = false"></sbnb-button>
    <sbnb-button label="Save" size="mini" (clicked)="setLanguages(langList.selectedOptions)"></sbnb-button>
  </div>
</div>
